<script>
import { onMounted, ref } from 'vue'
import { formatPrice } from '../../../Greativ/helper/price'
import { resizeUrl } from '../../../Greativ/helper/resize'

import {
  addToCart as storeAddToCart,
  loadProducts,
  products,
  productsTotalPriceWithVat,
  selectedProductsAmount,
} from '@/store/product'

import LoadingCard from '@/components/LoadingCard'
import Button from '@/components/Button'
import ProductsView from '@/components/Product/View'
import { loadSettings, seoByKey, priceFloat, currency } from '@/store/settings'

export default {
  components: {
    LoadingCard,
    Button,
    ProductsView,
  },
  setup() {
    const loading = ref(true)

    const addingCartLoading = ref(false)

    onMounted(async () => {
      const { success } = await loadSettings()
      await loadProducts()

      if (success && products.value.length) {
        loading.value = false
      }
    })

    const addToCartErrorMsg = ref('')
    const addToCart = async () => {
      addingCartLoading.value = true
      const { success, message } = await storeAddToCart()

      if (!success && message) {
        addToCartErrorMsg.value = message
        addingCartLoading.value = false
      } else {
       window.location.href = seoByKey('basket_url').value
      }
    }

    return {
      loading,
      productsTotalPriceWithVat,
      selectedProductsAmount,
      addToCart,
      addingCartLoading,
      addToCartErrorMsg,
      formatPrice,
      priceFloat,
      currency,
      resizeUrl,
    }
  },
}
</script>

<template>
  <div
    class="
      relative
      w-full
      text-blue-900
      bg-blue
      border-6px border-blue-900
      rounded
      px-6
      py-12
    "
  >
    <img
      :src="
        resizeUrl('ui/template/superSkypark/images/area/star.png', {
          fm: 'webp',
        })
      "
      :alt="__('buy_ticket_title')"
      class="absolute w-60 left-1/2 -translate-x-1/2 -top-30"
    />

    <h2 class="text-12 text-center uppercase mt-24">
      {{ __('buy_ticket_title') }}
    </h2>

    <div
      class="flex justify-center items-center flex-col min-h-100px"
      v-if="loading"
    >
      <LoadingCard />
    </div>

    <template v-else>
      <ProductsView :locked="addingCartLoading" />

      <div>
        <div
          class="
            flex
            justify-between
            items-center
            text-12
            font-bold
            uppercase
            mt-4
            mb-8
          "
        >
          {{ __('total_price_title') }}
          <span>
            {{
              `${currency} ${formatPrice(
                productsTotalPriceWithVat,
                priceFloat
              )}`
            }}
          </span>
        </div>

        <div
          class="text-white bg-red p-4 text-center rounded mb-4"
          v-if="addToCartErrorMsg"
        >
          {{ addToCartErrorMsg }}
        </div>

        <Button
          variant="secondary"
          size="full"
          :disabled="!selectedProductsAmount"
          :loading="addingCartLoading"
          @click="addToCart"
        >
          {{ __('btn_add_to_cart') }}
        </Button>
      </div>
    </template>
  </div>
</template>
